import styled from 'styled-components';

import backgroungImg from 'assets/sun-tornado.svg';
import { COLORS } from 'styles/constants';

export const Container = styled.div`
  width: 100%;
  min-height: 81vh;

  background: url(${backgroungImg}) no-repeat center fixed;
  background-size: cover;
  transition: height 0.3s;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 1400px) {
    min-height: 86vh;
  }
`;

export const EditingHeader = styled.div`
  margin: 30px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  h1 {
    color: #fff;
  }

  svg {
    cursor: pointer;
    transition: color 0.2s;
    color: #fff;
  }

  svg:hover {
    color: ${COLORS.darktext};
  }

  @media only screen and (max-width: 900px) {
    font-size: 10px;

    flex-direction: column;

    h1 {
      margin-bottom: 10px;
    }
  }
`;
